import { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import ProgressBar from './ProgressBar';
import Alert from 'react-s-alert';

const ImageUploader = ({
    isDraft,
    bucket,
    id,
    className = '',
    label = null,
    image = null,
    onUpload = () => {},
    showWarning = true,
    unique = false,
    allowRemoveImage = false
}) => {
    const [imageUrl, setImageUrl] = useState(image || null);
    const [file, setFile] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const fileInput = useRef();

    const envBucket = `${bucket}${process.env.REACT_APP_ENV === 'prod' ? '' : '_test'}`;

    useEffect(() => {
        if (image) {
            setImageUrl(image);
        }
    }, [image]);

    const reset = () => {
        setIsUploading(false);
        setFile(null);
        fileInput.current.value = '';
    };
    const handleChange = async (e) => {
        let file = e.target.files[0];

        if (!file) {
            reset();
            return false;
        }
        let al = showWarning
            ? window.confirm(`This cannot be undone, are you sure you want to upload ${file.name}?`)
            : true;
        if (!al) {
            reset();
            return false;
        }

        setFile(file);
        setIsUploading(true);

        let path = `${envBucket}/${id}`;
        if (unique) {
            path = `${path}-${Date.now()}`;
        }

        try {
            await axios.post(`/images/${path}`, file, {
                headers: {
                    'Content-Type': file.type
                },
                onUploadProgress: (event) => {
                    setUploadProgress(event.loaded);
                }
            });
            const newImageUrl = `${process.env.REACT_APP_IMAGE_URL}/${path}`;
            onUpload(newImageUrl);
            setImageUrl(newImageUrl);
            reset();
        } catch (err) {
            Alert.error('There was an error uploading your image.');
        }
    };

    return (
        <div className={className}>
            {showWarning && (
                <div className="flash flash-error">
                    <p>
                        <strong>Warning:</strong> Image Uploads are immediate, and will overwrite any existing images
                        currently live.
                    </p>
                </div>
            )}
            {label && <label htmlFor={`${bucket}_${id}`}>{label}</label>}
            <input id={`${bucket}_${id}`} ref={fileInput} type="file" accept="image/jpeg" onChange={handleChange} />
            {!isUploading && imageUrl && <img src={imageUrl} alt="" />}
            {isUploading && <ProgressBar current={uploadProgress} total={file.size} />}
            {!isUploading && !image && !imageUrl && <p>No Image Uploaded</p>}
            {allowRemoveImage && imageUrl && (
                <div>
                    <button
                        className="button button-danger"
                        onClick={() => {
                            onUpload('');
                            setImageUrl('');
                        }}
                    >
                        Remove Image
                    </button>
                </div>
            )}
        </div>
    );
};

export default ImageUploader;
